.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.muted {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.error {
  margin: 0;
  padding: var(--sp-4);
  background: var(--error-bg);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  color: var(--error);
  font-size: var(--fs-sm);
}

.ok {
  margin: 0;
  color: var(--ok);
  font-size: var(--fs-sm);
}

.warn {
  margin: 0;
  color: var(--warn);
  font-size: var(--fs-sm);
}

/* Полоса действий липнет к верху: документ длинный, а «Сохранить» нужна с
   любой его высоты — иначе после правки последнего вопроса надо мотать вверх. */
.bar {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  gap: var(--sp-4);
  padding: var(--sp-4) 0;
  background: var(--bg);
  border-bottom: var(--bw) solid var(--border);
}

.spacer {
  flex: 1;
}

.langPick {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  min-width: 12rem;
}

/* ── Блоки ───────────────────────────────────────────────────────────────── */

.block {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
}

.blockTitle {
  margin: 0;
  font-size: var(--fs-md);
  font-weight: 600;
}

/* ── Поля ────────────────────────────────────────────────────────────────── */

.field {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  min-width: 0;
}

.fieldLabel {
  color: var(--text-3);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* Подпись-адрес: моноширинная и строчными — видно, что это ключ, а не
   заголовок поля. */
.fieldKey {
  color: var(--text-3);
  font-family: var(--font-mono);
  font-size: var(--fs-xs);
}

.grid2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: var(--sp-4);
}

.grid3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: var(--sp-4);
}

/* ── Строки списков ──────────────────────────────────────────────────────── */

.row {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-4);
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
}

/* Выключенная строка гасится, но остаётся читаемой: её содержимое всё ещё
   правят — просто на странице её сейчас нет. */
.rowOff {
  opacity: 0.55;
}

.rowHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-3);
}

.id {
  padding: var(--sp-1) var(--sp-3);
  background: var(--surface-sunken);
  border-radius: var(--radius);
  color: var(--text-3);
  font-family: var(--font-mono);
  font-size: var(--fs-xs);
}

.tools {
  display: flex;
  gap: var(--sp-2);
  margin-left: auto;
}

.check {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  font-size: var(--fs-sm);
}

/* ── Переводы ────────────────────────────────────────────────────────────── */

.trRow {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding-top: var(--sp-4);
  border-top: var(--bw) solid var(--border);
}

/* Оригинал и перевод строго рядом: сравнивать их по вертикали через полэкрана
   невозможно, а именно этим переводчик и занят. */
.trPair {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--sp-4);
  align-items: start;
}

.trSource {
  margin: 0;
  padding: var(--sp-3) var(--sp-4);
  background: var(--surface-sunken);
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-md);
}

/* ── Лимиты ──────────────────────────────────────────────────────────────── */

.limit {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  min-width: 0;
}

.limitRow {
  display: flex;
  gap: var(--sp-3);
}

/* Число уже селектов: «10» не должно занимать столько же места, сколько
   «Без лимита», иначе строка расползается и вид значения теряется из виду. */
.limitNumber {
  max-width: 7rem;
}

/* ── Выбор строк для карточек ────────────────────────────────────────────── */

.picks {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  max-height: 20rem;
  margin: var(--sp-2) 0 0;
  padding: var(--sp-3);
  overflow-y: auto;
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  list-style: none;
}
